module.exports = __webpack_public_path__ + "media/images/icon__betPick--none-e78cf586490b990d9ae1e4d545da2422.png";